import {Pipe, PipeTransform} from '@angular/core';
import { format, parse } from 'libphonenumber-js';

@Pipe({
    name: 'sipContact',
    standalone: true
})
export class SipContactPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    const nameMatch = value.match(/"([^"]+)"/);
    const phoneMatch = value.match(/sip:\+?(\d+)/);

    const name = nameMatch ? nameMatch[1] : '';
    let phoneNumberString = phoneMatch ? phoneMatch[1] : '';

    if (phoneNumberString) {
      let phoneNumber = parse(phoneNumberString, {defaultCountry: 'US', extended: true});

      if (phoneNumber.valid) {
        if (phoneNumber.country === 'US') {
          phoneNumberString = format(phoneNumber, 'NATIONAL');
        } else {
          phoneNumberString = format(phoneNumber, 'INTERNATIONAL');
        }
      }
    }

    return name ? `${name}\n${phoneNumberString}` : phoneNumberString;
  }

}
